import SimpleHeader from "../../NewApp/SimpleHeader";
import "../IndexInvesting/IndexInvesting.css";
import book from "../../../assets/finliteracy.png";
import BookBlock from "../../reusable/BookBlock/BookBlock";
import Footer from "../../Footer/Footer";

const FinancialLiteracy: React.FC = () => (
  <div className="book-wrapper">
    <SimpleHeader onHome={() => window.location.href = '/'} onResources={() => window.location.href = '/resources'} />
    <div className="book-page-title">Կապիտալի հիմքը</div>
    <div className="book-page-description">Ուղեցույց ֆինանսական գրագիտության մասին</div>
    <div className="book-page-content">
        <BookBlock
        imageSrc={book}
        imageAlt={'financial literacy'}
        paragraphs={[
            'Սովորեք ֆինանսական գրագիտության հիմունքները՝ բանկային համակարգից, բյուջետավորումից մինչև ներդրումներ։',
            'Փաստ է, որ ինչքան շուտ սկսենք հասկանալ փողը, այդքան կմեծացնենք մեր հաջողակ դառնալու հավանականությունը։',
            'Չափահաս տարիքում մենք կայացնում ենք միլիոնավոր որոշումներ, որոնք կապված են բանկերի, վարկերի, հաշիվների, աշխատավարձի, բյուջեի, ծախսերի ու ներդրումների հետ։',
            'Բնական հարց է ծագում՝ «ինչու՞ չկա ուղեցույց, որ կարող ենք կարդալ չափահաս դառնալուն պես և հասկանալ ֆինանսական համակարգը»։',
            'Այս ուղեցույցը ստեղծված է բոլոր նրանց համար, ովքեր ցանկանում են կառուցել ամուր ֆինանսական հիմք և ապահովել իրենց ապագան։',
            `<a href="/finliteracy.pdf" target="_blank" rel="noopener noreferrer">Ներբեռնել PDF տարբերակը</a>`]}
      />
    </div>
    <Footer></Footer>
  </div>
);

export default FinancialLiteracy;
